let http = {};
import axios from 'axios';
import utils from './utils';
import config from '../config/config';

// 自定义异常处理方式
function custErrStatusFun(vm, errStatus, errMsg) {
    utils.hideLoading(vm);
    switch (errStatus) {
        case 404:
            utils.error(errMsg || '404')
            break;
        case 403:
            utils.error(errMsg || '没有权限');
            vm.$router.push({
                name:'login'
            })
            break;
        default:
            utils.error(errMsg || '请求失败')

    }
}

// 自定义异常处理方式
function custErrFun(vm, err) {
    if(err.status == 500 || (err.response && err.response.status == 500)){
        utils.hideLoading(vm);
        utils.error('请求失败');
    }else if (err.response && err.response.status !== 200) {
        if(err.response.status == 403){
            vm.$router.push({
                name:'login'
            })
            utils.hideLoading(vm);
        }else{
            utils.hideLoading(vm);
            utils.error(err.response.data.msg || '请求失败');
        }
    }
    else if (err.message && err.stack) {
        console.log(err);
    } else {
        // TODO 超时处理机制
        // 请求返回的异常
        var errStatus = err.response.status;
        custErrStatusFun(vm, errStatus);

    }
}


// 自定义返回处理
function custResponseFun(vm, res, resolve) {
    // 返回的状态
    const responseStatus = res.data.status || res.data.code;
    const responseMsg = res.data.msg || res.data.messageList;
    switch (responseStatus) {
        case 200:
            resolve(res);
            break;
        default:
            custErrStatusFun(vm, responseStatus, responseMsg);
    }
}

// get 请求
http.get = function (vm, url, params) {

    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params || {},
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'authorization': vm.$store.state.token
            },
            timeout: config.httpTimeOut
        })
            .then(res => {
                custResponseFun(vm, res, resolve);
            })
            .catch(err => {
                custErrFun(vm, err);
            })
    });
};

// POST 请求
http.post = function (vm, url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'authorization': vm.$store.state.token
            },
            timeout: config.httpTimeOut,
            // responseType:'blob'
        })
            .then(res => {
                custResponseFun(vm, res, resolve);
            })
            .catch(err => {
                custErrFun(vm, err);
            })
    });
};

// DELETE 请求
http.del = function (vm, url) {
    return new Promise((resolve, reject) => {
        axios.delete(url, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'authorization': vm.$store.state.token
            },
            timeout: config.httpTimeOut
        })
            .then(res => {
                custResponseFun(vm, res, resolve);
            })
            .catch(err => {
                custErrFun(vm, err);
            })
    });
};

http.postFormData = function (vm, url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'authorization': vm.$store.state.token
            },
            timeout: config.httpTimeOut
        })
            .then(res => {
                custResponseFun(vm, res, resolve);
            })
            .catch(err => {
                custErrFun(vm, err);
            })
    });
};

// PUT 请求
http.put = function (vm, url, params) {
    return new Promise((resolve, reject) => {

        axios.put(url, params, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'authorization': vm.$store.state.token
            },
            timeout: config.httpTimeOut
        })
            .then(res => {
                custResponseFun(vm, res, resolve);
            })
            .catch(err => {
                custErrFun(vm, err);
            })
    });
};

// ajaxPost
http.pdfPost = function (vm, url, param, suc, err) {
    axios.post(url, param,
        {
            headers: {
                'Content-Type': 'application/json',
                'authorization': vm.$store.state.token
            },
            timeout: config.httpTimeOut,
            responseType:'blob'
        })
        .then(function (response) {
            if (response.status === 200 || response.data.status === 200) {
                if (response.data.status !== undefined && response.data.status !== 200) {
                    utils.error(response.data.messageList[0].messageBody);
                    vm.showFix = false;
                } else {
                    suc(response);
                }
            } else {
                utils.error(response.data.messageList[0].messageBody);
                vm.showFix = false;
            }
        }).catch(function (error) {
            console.log(error);
            if (utils.isContains(error.message, 'timeout') || error.response.status === 504) {
                utils.error('请求超时');
                vm.showFix = false;
            }
            else if (error.response.status === 403) {
                // 跳转登录
                utils.logout(vm);
            } else {
                var msg = error.response.data.messageList[0].messageBody;
                if (utils.notNull(msg)) {
                    utils.error(msg);
                } else {
                    utils.error(msgCfg.sysError);
                }
                vm.showFix = false;
                // util.error('系统异常，请稍后重试！');
            }
        });
};



// PUT 请求
// DELETE 请求
// PATCH 请求
// POST FORM-DATA

export default http;